import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';

import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';

import SelectField from '../fields/SelectField';
import SwitchField from '../fields/SwitchField';
import TextField from '../fields/TextField';

import { getDefaultCompanies, isAdmin, isSubcontractor, isSubcontractorForUser } from '../../modules/selectors/permissions';
import RolesField from '../fields/RolesField';


class ApiUserForm extends Component {
  static propTypes = {
    // state props
    companies: PropTypes.array.isRequired,
    defaultCompanies: PropTypes.array.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isSubcontractor: PropTypes.bool.isRequired,
    isSubcontractorForUser: PropTypes.bool.isRequired,

    // dispatch props
    handleSubmit: PropTypes.func.isRequired,
    readEndpoint: PropTypes.func.isRequired,

    // own props
    apiUserFieldsDisabled: PropTypes.bool,
    handleDelete: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const { readEndpoint } = this.props;

    readEndpoint('company?filter[deleted-at__isnull]=True');
  };

  render() {
    const {
      classes,
      error,
      pristine,
      submitting,
      initialValues,
      handleSubmit,
      companies,
      defaultCompanies,
      isAdmin,
      isSubcontractor,
      isSubcontractorForUser,
      apiUserFieldsDisabled,
      handleDelete,
    } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        {error && <Typography variant="subtitle1">{error}</Typography>}

        {(isAdmin || isSubcontractorForUser) && initialValues && (
          <Field name="is_active" component={SwitchField} label="Actief" id="api_user_form_is_active" />
        )}

        <Field
          name="text_notification"
          component={SwitchField}
          label="SMS bericht"
          id="api_user_form_text_notification"
        />

        <Field
          name="first_name"
          component={TextField}
          label="Voornaam"
          fullWidth
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_first_name"
        />

        <Field
          name="last_name"
          component={TextField}
          label="Achternaam"
          fullWidth
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_last_name"
        />

        <Field
          name="phone"
          component={TextField}
          label="Telefoonnummer"
          fullWidth
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_phone"
        />

        <Field
          name="phone_24h_2"
          component={TextField}
          label="Telefoonnummer 2"
          fullWidth
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_phone_24h_2"
        />

        <Field
          name="email"
          component={TextField}
          label="E-mailadres"
          fullWidth
          autoComplete="new-email"
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_email"
        />

        <Field
          name="password"
          component={TextField}
          label="Wachtwoord"
          fullWidth
          type="password"
          autoComplete="new-password"
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_password"
        />

        <br />
        <Typography variant="subtitle1" component="b">Gebruikersrollen</Typography>
        <Divider />

        <Field
          name="default_company"
          component={SelectField}
          label="Standaardbedrijf"
          disabled={!!apiUserFieldsDisabled}
          id="api_user_form_default_company"
        >
          {defaultCompanies.map(company => (
            <MenuItem key={'company-' + company.id} value={company.id}>{company.attributes.name}</MenuItem>
          ))}
        </Field>

        <Divider />
        <Field
          name="roles"
          component={RolesField}
          label="Gebruikersrollen"
          companies={companies}
          isAdmin={isAdmin}
        />

        <CardActions className={classes.cardActions}>
          {(isAdmin || isSubcontractor) && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDelete()}
            >
              Verwijderen gebruiker
            </Button>
          )}
          <Button
            disabled={pristine || submitting}
            variant="contained"
            color="primary"
            type="submit"
          >
            {initialValues ? 'Wijzig gebruiker' : 'Voeg gebruiker toe'}
          </Button>
        </CardActions>
      </form>
    );
  };
}


/**
 * Redux state/dispatch mapping.
 */
const mapStateToProps = (state, props) => ({
  companies: state.api.company && state.api.company.data || [],
  defaultCompanies: getDefaultCompanies(state, props),
  isAdmin: isAdmin(state),
  isSubcontractor: isSubcontractor(state),
  isSubcontractorForUser: isSubcontractorForUser(state, props),
});

const mapDispatchToProps = {
  readEndpoint,
};

/**
 * Redux Form binding.
 */
ApiUserForm = reduxForm({
  form: 'apiUserForm',
  validate: (values) => {
    const errors = {};

    if (!values.email) errors.email = 'Verplicht (voorbeeld: h.devries@arrivatouring.nl)';
    if (!values.first_name) errors.first_name = 'Verplicht (voorbeeld: Henk)';
    if (!values.last_name) errors.last_name = 'Verplicht (voorbeeld: de Vries)';
    if (!values.phone) errors.phone = 'Verplicht (voorbeeld: 0505260268)';

    if (!values.default_company) errors.default_company = 'Verplicht (kies een van de bedrijven als standaardbedrijf)';
    if (!values.roles || values.roles.length === 0) errors.roles = 'Verplicht (voeg tenminste één rol toe)';

    return errors;
  },
})(ApiUserForm);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles({
  cardActions: {
    justifyContent: 'flex-end',
    marginTop: 20,
  },
})(ApiUserForm));
